<template>
<div class="viewer-header">
    <HeaderText v-if="channel.useTextHeader" :channel="channel"/>
    <HeaderImage v-else :headerImgUrl="channel.headerImgUrl"/>
</div>
</template>

<script>
import { mapState } from 'vuex'

import HeaderText from '@/components/viewer/header/HeaderText'
import HeaderImage from '@/components/viewer/header/HeaderImage'

export default {
    name: 'ViewerHeader',
    computed: mapState(['channel']),
    components: {
        HeaderText,
        HeaderImage,
    }
}
</script>

<style lang="scss" scoped>

</style>
